import { ButtonProps, Button } from "@mui/material";
import { InputProps } from "../Input";

export type UploadButtonProps = Omit<ButtonProps, "onChange"> & {
  onChange?: InputProps["onChange"];
};

export const UploadButton = (props: UploadButtonProps) => {
  return (
    <div>
      <label htmlFor="upload-button">
        <input
          style={{ display: "none", width: "0px" }}
          id="upload-button"
          name="upload-button"
          type="file"
          data-testid="upload-button"
          onChange={props.onChange}
        />
        <Button
          color="secondary"
          variant="outlined"
          component="span"
          sx={{
            borderRadius: 0,
            textTransform: "none",
            fontWeight: "bold",
            width: "90%",
            ...props.sx,
          }}
        >
          {props.children}
        </Button>
      </label>
    </div>
  );
};
